/* src/app/components/analytics/case-notes/case-notes-editor/case-notes-editor.component.scss */
.container {
  margin: 20px auto;
  padding: 0 20px;
  flex: 1 1 0;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
  place-content: stretch space-between;
  align-items: stretch;
}
.container > mat-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.search-control {
  justify-content: flex-end;
}
.search-control > mat-form-field {
  font-size: 12px;
}
.form-control-wrapper {
  padding-bottom: 10px;
}
.form-control-wrapper mat-form-field {
  width: 100%;
}
.created-by {
  padding: 15px 0;
  font-size: 0.95rem;
}
.page-number-control {
  max-width: 180px;
}
.mat-mdc-card.scrollable-content {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  flex: 1 1;
}
.mat-mdc-card.scrollable-content > .mat-mdc-card-content {
  overflow-y: auto;
  flex: 1 1;
}
.document-button-text {
  display: flex;
  align-items: center;
}
.document-button-text mat-icon {
  margin-right: 5px;
}
.note-list-item {
  border-radius: 4px;
  background-color: #E4E4E4;
  margin-bottom: 8px;
}
.note-list-item > div {
  padding: 3px;
  line-height: 20px;
}
/*# sourceMappingURL=case-notes-editor.component.css.map */
